var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseRadioGroup',_vm._b({attrs:{"name":"customerType","items":_vm.customerTypes,"radio-button-styles":_vm.$style.radio},on:{"input":function($event){return _vm.$emit('input', $event)}}},'BaseRadioGroup',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }